// Whether a signed-in user holds a Spatie permission — through a role, or
// granted to them directly (docs/authorization/direct-permissions.md).
//
// One definition. useCan, the router's RequirePermission and the sidebar each
// kept a copy until 2026-10-07, and only useCan counted direct grants: a user
// given `manage billing` directly saw the page's buttons, but the router sent
// them home and the sidebar hid the link.

/**
 * @param {object|null} user     the `/api/auth/status` user
 * @param {string} ability       a PERM value (@shared/constants/permissions)
 */
export const holdsPermission = (user, ability) => {
  if (!user || !ability) return false;
  const named = (p) => p?.name === ability;
  return Boolean(
    user.roles?.some((role) => role?.permissions?.some(named)) || user.permissions?.some(named),
  );
};
